export default __webpack_public_path__ + "static/media/Wikipedia.30507035.svg";